import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import ProtectedRoute from "@/components/feature/ProtectedRoute";
import HomeGate from "@/components/feature/HomeGate";

import LoginPage from "@/pages/login/page";
import RegisterPage from "@/pages/register/page";
import PricingPage from "@/pages/pricing/page";
import BillingPage from "@/pages/billing/page";
import BillingSuccessPage from "@/pages/billing/success";
import BillingCancelledPage from "@/pages/billing/cancelled";
import ContractList from "@/pages/contracts/page";
import ContractDetail from "@/pages/contract-detail/page";
import ContractForm from "@/pages/contract-form/page";
import AlertsSettings from "@/pages/alerts/page";
import DepartmentsUsers from "@/pages/departments/page";
import Reports from "@/pages/reports/page";
import SupplierReviewsList from "@/pages/supplier-reviews/page";
import SupplierPerformance from "@/pages/supplier-performance/page";
import ReviewForm from "@/pages/review-form/page";
import SLAMatrix from "@/pages/sla-matrix/page";
import NotFound from "@/pages/NotFound";

function Protected({ children }: { children: React.ReactNode }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "/billing/success",
    element: <BillingSuccessPage />,
  },
  {
    path: "/billing/cancelled",
    element: <BillingCancelledPage />,
  },
  { path: "/", element: <HomeGate /> },
  { path: "/billing", element: <Protected><BillingPage /></Protected> },
  { path: "/contracts", element: <Protected><ContractList /></Protected> },
  { path: "/contracts/new", element: <Protected><ContractForm /></Protected> },
  { path: "/contracts/:id", element: <Protected><ContractDetail /></Protected> },
  { path: "/contracts/:id/edit", element: <Protected><ContractForm /></Protected> },
  { path: "/alerts", element: <Protected><AlertsSettings /></Protected> },
  { path: "/departments", element: <Protected><DepartmentsUsers /></Protected> },
  { path: "/reports", element: <Protected><Reports /></Protected> },
  { path: "/supplier-reviews", element: <Protected><SupplierReviewsList /></Protected> },
  { path: "/supplier-reviews/new", element: <Protected><ReviewForm /></Protected> },
  { path: "/supplier-reviews/:id", element: <Protected><SupplierPerformance /></Protected> },
  { path: "/sla-matrix", element: <Protected><SLAMatrix /></Protected> },
  { path: "*", element: <NotFound /> },
];

export default routes;
